import { useEffect } from 'react';

/**
 * Component to handle automatic redirect from non-www to www domain
 * This ensures boholtrabaho.com redirects to www.boholtrabaho.com
 */
const WwwRedirect = () => {
  useEffect(() => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;
    
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const pathname = window.location.pathname;
    const search = window.location.search;
    const hash = window.location.hash;
    
    // Check if we're on the production domain without www
    if (hostname === 'boholtrabaho.com') {
      // Redirect to www version
      const newUrl = `${protocol}//www.${hostname}${pathname}${search}${hash}`;
      console.log('[WwwRedirect] Redirecting to www version:', newUrl);
      window.location.replace(newUrl);
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default WwwRedirect;
